import { useTranslation } from 'react-i18next';
import { Button } from '@/components/livekit/button';

interface GuestWelcomeViewProps {
  participantName: string;
  onStartCall: () => void;
}

export const GuestWelcomeView = ({
  participantName,
  onStartCall,
  ref,
}: React.ComponentProps<'div'> & GuestWelcomeViewProps) => {
  const { t } = useTranslation();

  return (
    <div ref={ref} className="w-full max-w-full overflow-x-hidden">
      <section className="bg-background flex flex-col items-center justify-center text-center px-4 sm:px-6 w-full max-w-full overflow-hidden box-border">
        <div className="flex flex-col items-center gap-2">
          <span className="rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground uppercase tracking-wide">
            {t('guest.badge')}
          </span>
          <p className="text-foreground max-w-xl pt-1 text-lg leading-7 font-semibold">
            {t('guest.welcome')}
          </p>
          {participantName && (
            <p className="text-muted-foreground max-w-2xl text-base leading-6">
              {t('guest.welcomeName', { name: participantName })}
            </p>
          )}
          <p className="text-muted-foreground max-w-2xl text-sm leading-6 mt-2">
            {t('guest.description')}
          </p>
        </div>

        <Button
          variant="primary"
          size="lg"
          onClick={onStartCall}
          className="mt-6 w-64 font-semibold"
        >
          {t('guest.startButton')}
        </Button>

        <p className="text-muted-foreground text-xs mt-4 max-w-md">
          {t('guest.microphoneHint')}
        </p>
      </section>
    </div>
  );
};
